import { HiOutlineX } from "react-icons/hi";
import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";

export const StyledWrapper = styled(Flex)`
  align-items: center;
  height: 100vh !important;
  justify-content: center;
  width: 100vw !important;
`;

export const EmbeddablePlayerWrapper = styled(Box)`
  position: relative;
  width: 100%;
  .video-js {
    height: 100vh !important;
    width: 100vw !important;
  }
  .vjs-tech {
    height: 100% !important;
    width: 100% !important;
  }

  .embeddable-player {
    .video-js .vjs-control-bar {
      background: transparent !important;
      padding-bottom: 4px !important;
    }

    .video-js .vjs-picture-in-picture-control {
      display: none !important;
    }

    .video-js .vjs-volume-bar,
    .video-js .vjs-volume-level {
      background-color: ${({ theme }) => theme.colors.envy} !important;
    }

    .video-js .vjs-volume-handle {
      background-color: ${({ theme }) => theme.colors.envy} !important;
    }

    .video-js .vjs-slider {
      background-color: rgba(255, 255, 255, 0.3);
    }

    .video-js .vjs-slider .vjs-slider-bar {
      background-color: ${({ theme }) => theme.colors.envy} !important;
    }

    .video-js .vjs-play-control {
      align-items: center !important;
      display: flex;
      font-size: 1.4em !important;
      height: 100% !important;
      justify-content: center !important;
    }

    .video-js .vjs-fullscreen-control,
    .video-js .vjs-mute-control {
      align-items: center !important;
      display: flex !important;
      font-size: 1.2em !important;
      height: 100% !important;
      justify-content: center !important;
    }

    .video-js .vjs-play-control .vjs-control-text,
    .video-js .vjs-fullscreen-control .vjs-control-text,
    .video-js .vjs-mute-control .vjs-control-text {
      display: none !important;
    }

    .video-js .vjs-play-control .vjs-icon-placeholder,
    .video-js .vjs-fullscreen-control .vjs-icon-placeholder,
    .video-js .vjs-mute-control .vjs-icon-placeholder {
      align-items: center !important;
      display: flex !important;
      justify-content: center !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .video-js .vjs-play-control .vjs-icon-placeholder:before,
    .video-js .vjs-fullscreen-control .vjs-icon-placeholder:before,
    .video-js .vjs-mute-control .vjs-icon-placeholder:before {
      position: static !important;
    }

    /* these are extra time displays we don't want to show */
    .video-js .vjs-current-time,
    .video-js .vjs-current-time-display,
    .video-js .vjs-duration,
    .video-js .vjs-duration-display,
    .video-js .vjs-time-divider {
      display: none !important;
    }

    .video-js .vjs-remaining-time {
      align-items: center !important;
      display: flex;
      font-size: 1.2em !important;
      font-weight: 600 !important;
      height: 100% !important;
    }

    .video-js .vjs-volume-panel {
      margin-left: -4px !important;
    }
  }
`;

export const SlideInAdContainer = styled(Box)`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  display: block;
  pointer-events: auto;
`;

export const TopLeftBugContainer = styled(Box)<{ $visible: boolean }>`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
  display: ${({ $visible }) => ($visible ? "block" : "none")};
  pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};
  mix-blend-mode: screen;
`;

export const PauseAdGridOverlay = styled(Box)<{ $hasAd: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $hasAd }) =>
    $hasAd ? "rgba(0, 0, 0, 0.7)" : "transparent"};
  z-index: 10;
  pointer-events: ${({ $hasAd }) => ($hasAd ? "auto" : "none")};
`;

export const MaxWidthContainer = styled(Box)`
  max-width: 700px;
`;

export const ClipThumbnail = styled(Box)<{ snapshot?: string }>`
  align-items: center;
  background-image: url("${(props) => props.snapshot}"),
    url("https://media.allstar.gg/static/fallback.jpg");
  background-size: cover;
  bottom: 0;
  justify-content: center;
  left: 0;
  opacity: 0.1;
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
`;

export const CloseButton = styled(HiOutlineX)`
  cursor: pointer;
  height: 15px;
  width: 15px;

  color: ${(props) => {
    return props.theme.colors.ice;
  }};

  &:hover {
    color: ${(props) => {
      return props.theme.colors.envy;
    }};
  }

  @media (max-width: 540px) {
    height: 13px;
    width: 13px;
  }
`;

// Ramp ad containers — Ramp auto-injects creatives into elements with these IDs
export const RampTopRight = styled(Box)`
  position: absolute;
  top: -30px;
  right: 0;
  z-index: 10;
  pointer-events: auto;
`;

export const RampBottomCenter = styled(Box)`
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  z-index: 10;
  pointer-events: auto;
  display: flex;
  justify-content: center;
`;

export const RampCenterOverlay = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
`;

export const MidRollAdContainer = styled(Flex)`
  position: absolute;
  top: -30px;
  left: 0;
  right: 0;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
`;

export const MidRollCountdownBanner = styled(Flex)`
  align-items: center;
  background: rgba(0, 0, 0, 0.85);
  border-radius: 6px;
  color: #cddcfe;
  font-size: 12px;
  font-weight: 600;
  gap: 8px;
  padding: 8px 16px;
`;

export const AdClickOverlay = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  cursor: pointer;
  /* Invisible but still captures clicks */
  background: transparent;
  pointer-events: auto;
  cursor: pointer;
`;
